/* istanbul ignore file */
import * as codec from 'purify-ts/Codec';
import { array as codecArray, oneOf as codecOneOf, string as codecString } from 'purify-ts/Codec';
import { parsers } from '@codegrade/utils';
import { BaseError } from './BaseError';
import { CGIgnoreVersion } from './CGIgnoreVersion';
import { ExtractFileTreeDirectory } from './ExtractFileTreeDirectory';
import { FileDeletion } from './FileDeletion';
import { FileRule } from './FileRule';
import { MissingFile } from './MissingFile';
const IgnoredFilesExceptionParser = 
/* #__PURE__ */ /* #__PURE__ */ codec.intersect(
/* #__PURE__ */ parsers.object([
    ['removedFiles', /* #__PURE__ */ codecArray(FileDeletion), 'removed_files'],
    [
        'invalidFiles',
        /* #__PURE__ */ codecArray(
        /* #__PURE__ */ codecArray(
        /* #__PURE__ */ codecOneOf([FileRule, codecString, codecString]))),
        'invalid_files',
    ],
    ['originalTree', ExtractFileTreeDirectory, 'original_tree'],
    ['filterName', CGIgnoreVersion, 'filter_name'],
    ['missingFiles', /* #__PURE__ */ codecArray(MissingFile), 'missing_files'],
]), BaseError);
export class IgnoredFilesException extends BaseError {
    static decode(input) {
        return IgnoredFilesExceptionParser.decode(input).map(res => new IgnoredFilesException(res));
    }
    static unsafeDecode(input) {
        return IgnoredFilesException.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return IgnoredFilesExceptionParser.encode(data);
    }
    static schema() {
        return IgnoredFilesExceptionParser.schema();
    }
}
